import React from "react";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import { useService } from '../ServiceContext';

const ServiceDoctors = () => {
  const { service } = useService();
  // Check if service and availableDoctors exist
  if (!service?.availableDoctors) {
    return <div>Loading doctors data...</div>;
  }

  return (
    <div className="w-full flex justify-center items-center px-2 md:px-0 pt-12 pb-28">
      <div className="2xl:w-3/4 3xl:w-2/3 xl:w-[93%] w-[95%] h-auto flex gap-8 border-b-[1px] md:pb-36 pb-24 flex-col relative overflow-hidden">
        <h2
          data-aos="fade-right"
          data-aos-easing="ease-in-back"
          data-aos-delay="100"
          data-aos-offset="0"
          className="font-heading text-[38px] font-[500] leading-[1.316em] mb-6 text-thickGreen"
        >
          {service.availableDoctors.title}
        </h2>

        <div
          data-aos="fade-up"
          className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
        >
          {service.availableDoctors.Doctors.map((doctor, index) => (
            <div
              key={index}
              className="w-full flex h-[400px] bg-lightOrange justify-center rounded-3xl items-center"
            >
              <div className="w-full flex flex-col gap-8 justify-center items-center">
                <div className="flex justify-center rounded-full w-44 h-44 items-center overflow-hidden group">
                  <img
                    src={doctor.photo}
                    className="object-cover w-44 h-44 rounded-full group-hover:scale-105 transition-all group-hover:duration-200 group-hover:cursor-pointer"
                    alt={doctor.doctorName}
                  />
                </div>
                <div className="w-full flex xl:flex-row flex-col gap-4 justify-between px-8">
                  <div>
                    <h3 className="text-[22px] leading-[1.273em] font-heading text-thickGreen mb-1.5">
                      {doctor.doctorName}
                    </h3>
                    <div className="text-[18px] leading-[1.111em] font-heading text-lightGreen mb-1.5">
                      {doctor.profession}
                    </div>
                  </div>
                  <div className="flex flex-row gap-2">
                   
                    <a href="tel:+917993999044" className="w-12 h-12 rounded-full border-[1px] flex justify-center items-center border-thickGreen font-medium  text-thickGreen bg-white hover:bg-lightGreen transition-all hover:duration-200 hover:border-none hover:text-white">
                      <LocalPhoneIcon className="text-5xl" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServiceDoctors;